module.exports = __webpack_public_path__ + "static/media/exceptional.svg.43cbc6dc.png";